import React, { useState } from "react";
import { Validation } from "../../../../_helpers/validation/Validation";
import Button from "../CommonComponents/Button";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import InputMobileNumber from "../CommonComponents/InputMobileNumber";
import InputText from "../CommonComponents/InputText";
import { userDetail } from "./constant";
import { useTranslation } from "react-i18next";
import style from "./style.module.css";
import { HomePageServices } from "../../../../_services/Arya2.0/HomePageServices";
import Loader from "../CommonComponents/Loader/Loader";
import { customToastr } from "../CustomToastr";
import { isNumberOnly } from "../CommonFunctions/Function";
import { CALL_BACK_BANNER } from "../GATracker3.0/constants";
import { useLocation } from "react-router";
import { eventTracker } from "../GATracker3.0/eventTracker";
import ReCAPTCHA from "react-google-recaptcha";
import ValidationError from "../CommonComponents/ValidationError/ValidationError";
import { captchaKey } from "../../../../_constants/Config/AryaConstants";
import { isMobile } from "../helperFunc";
import useUserDetails from "../CustomHooks/useUserDetails";
import useIsUserLoggedIn from "../CustomHooks/useIsUserLoggedIn";
const initiate = {
  name: "",
  number: "",
  captchaToken: "",
};
const GetInTouch = (props) => {
  const { t: translation } = useTranslation();
  const [data, setData] = useState(initiate);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [captchaKeyRest, setCaptchaKeyRest] = useState(0);
  const [userLoggedIn] = useIsUserLoggedIn();
  const onChange = (e) => {
    const { name, value } = e.target;
    const isNumberValid = value ? isNumberOnly(value) : true;

    if (name === "name" || (value.toString().length <= 10 && isNumberValid)) {
      setData((prev) => ({ ...prev, [name]: value }));
    }
  };
  // const handleRefresh = () => {
  //   setCaptchaKeyRest((prevKey) => prevKey + 1);
  // };
  const captchChange = (value) => {
    setError((prev) => ({
      ...prev,
      ["captchaToken"]: "",
    }));
    setData((prev) => ({ ...prev, ["captchaToken"]: value }));
  };

  const onExpired = (value) => {
    setData((prev) => ({ ...prev, ["captchaToken"]: "" }));
  };
  const location = useLocation();
  const onSubmit = async () => {
    let errobj = {};
    errobj = Validation(data, userDetail());
    if (!userLoggedIn && !data?.captchaToken) {
      errobj.captchaToken = translation(
        "Please check the box indicating 'I am not a robot' to submit your application"
      );
    }
    setError(errobj);
    let flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      let registerdata = {
        first_name: data.name,
        phone_number: data.number,
        captcha_token: data.captchaToken,
      };
      setIsLoading(true);
      const result = await HomePageServices.getCallBack(registerdata);
      if (result && result.status_code === 200) {
        // toastr.info("Request submitted");
        eventTracker("event", CALL_BACK_BANNER, {
          pagename: location.pathname === "/" ? "homepage" : location.pathname,
          addinfo: registerdata.first_name?.length
            ? "name+phone filled"
            : "phone filled",
        });
        customToastr({
          text: "Thanks, we will get in touch soon",
        });
        // handleRefresh();
        setApiSuccess(true);
      }
      setIsLoading(false);
    }
  };
  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      {!apiSuccess && (
        <Card
          className={` boxRadius8   margin16 padding16  ${style["backDropFilters"]}`}
        >
          <HeadLines
            className="padding-bottom12 font-weight500"
            text="Get in touch with arya.ag"
          />
          <HeadLines
            className="font-weight400 font-size12 line-height14 letterSpacing025 colorDark6 padding-bottom16"
            text="Our representative will reach out to you to share some more information."
          />
          <HeadLines
            className="font-weight400 font-size14 line-height16 letterSpacing05  padding-bottom8"
            text="Your Name (Optional)"
          />
          <InputText
            className={`padding12 boxRadius8 width-100 font-weight400 font-size14 line-height16 letterSpacing05 colorDark9`}
            placeholder="eg. Deepak Saxena"
            value={data.name}
            onChange={onChange}
            name="name"
            // showError={error.name}
          />
          <HeadLines
            className="font-weight400 font-size14 line-height16 letterSpacing05 padding-top12 padding-bottom8"
            text="Your Contact Number"
          />
          <InputMobileNumber
            className1={`padding-top12 padding-bottom12 ${style["padding-left50"]} boxRadius8 width-100 font-weight400 font-size14 line-height16 letterSpacing05 colorDark9`}
            className2={`colorDark9 ${style["positionTopBottom"]}`}
            value={data.number}
            onChange={onChange}
            name="number"
            showError={translation(error.number)}
            errorClassName={"margin-top4"}
          />
          {!userLoggedIn && (
            <div className="margin-top16">
              <ReCAPTCHA
                // key={captchaKeyRest}
                sitekey={captchaKey}
                onChange={captchChange}
                onExpired={onExpired}
              />
              {error.captchaToken && (
                <ValidationError
                  text={error.captchaToken}
                  imageClassName={isMobile && "mt-1"}
                  // imageClassName={isMobile ? "" : style["width-18"]}
                  textClassName={style["input-error-style-captcha"]}
                />
              )}
            </div>
          )}
          <Button
            className={`${style["backgroundColorRadius"]} margin-top16 textColorWhite padding8 width-100 font-weight400 font-size14 line-height16 letterSpacing0125 `}
            title="Get a Callback"
            onClick={onSubmit}
          />
        </Card>
      )}
    </>
  );
};
export default GetInTouch;
